/* LN Innovations analytics. No field values are collected; only allowlisted campaign query parameters are retained. */
(function () {
  'use strict';
  if (window.__lnAnalyticsInstalled || window.Shopify && window.Shopify.designMode) return;
  window.__lnAnalyticsInstalled = true;
  var container = 'GTM-PHRPZWLC';
  var allowed = false, loaded = false, ready = false;
  var forms = {LNContactForm:'contact',LNProjectForm:'project',LNConfiguratorDemoForm:'configurator_demo'};
  var started = {}, stepsSeen = {}, leadChecked = false;
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  gtag('consent','default',{analytics_storage:'denied',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});
  function cleanUrl(value, campaign) {
    try {
      var u=new URL(value,location.origin);
      if(!/^https?:$/.test(u.protocol))return '';
      var out=new URL(u.origin+u.pathname);
      if(campaign)['utm_source','utm_medium','utm_campaign','utm_id','utm_term','utm_content','gclid','dclid','gbraid','wbraid'].forEach(function(key){
        var v=u.searchParams.get(key);
        if(v && v.length<=200 && /^[a-zA-Z0-9_. ~-]+$/.test(v))out.searchParams.set(key,v);
      });
      return out.href;
    } catch(e) { return ''; }
  }
  function emit(name, values) {
    if (!allowed || !ready) return;
    window.dataLayer.push(Object.assign({event:'ln_analytics',ln_event_name:name,form_name:'',step_number:0,contact_method:'',link_path:'',page_location:cleanUrl(location.href,true),page_referrer:document.referrer?cleanUrl(document.referrer):''},values||{}));
  }
  function storageGet(key) { try { return sessionStorage.getItem(key); } catch(e) {return null;} }
  function storageSet(key,value) { try { sessionStorage.setItem(key,value); } catch(e) {} }
  function storageRemove(key) { try { sessionStorage.removeItem(key); } catch(e) {} }
  function checkLead() {
    if (!allowed || !ready || leadChecked) return;
    leadChecked=true;
    document.querySelectorAll('[data-ln-lead-success]').forEach(function(marker) {
      var name=marker.getAttribute('data-ln-lead-success'), key='ln_pending_'+name;
      var pending=Number(storageGet(key));
      storageRemove(key);
      if (pending && Date.now()-pending>=0 && Date.now()-pending<1800000) emit('generate_lead',{form_name:name});
    });
  }
  function activate() {
    if (loaded) return;
    loaded=true;
    gtag('consent','update',{analytics_storage:'granted',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});
    window.dataLayer.push({'gtm.start':Date.now(),event:'gtm.js'});
    var script=document.createElement('script');script.async=true;
    script.src='https://www.googletagmanager.com/gtm.js?id='+container;
    document.head.appendChild(script);
    ready=true;
    window.dataLayer.push({event:'ln_analytics_ready',page_location:cleanUrl(location.href,true),page_referrer:document.referrer?cleanUrl(document.referrer):''});
    checkLead();
  }
  function sync() {
    var privacy=window.Shopify && Shopify.customerPrivacy;
    if (!privacy) return;
    var consent=privacy.currentVisitorConsent();
    var wasAllowed=allowed;
    allowed=consent.analytics==='yes';
    if (allowed) activate();
    if (wasAllowed && !allowed) {
      gtag('consent','update',{analytics_storage:'denied',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});
      Object.keys(forms).forEach(function(id){storageRemove('ln_pending_'+forms[id]);});
      location.reload();
    }
  }
  function consentUi() {
    // Reuse Shopify's existing banner and its documented reshow link convention.
    var legal=document.querySelector('.ln-footer__legal-list');
    if(legal && !legal.querySelector('a[href="#shopifyReshowConsentBanner"]')) {
      var item=document.createElement('li'), link=document.createElement('a');
      link.href='#shopifyReshowConsentBanner';link.textContent='Cookievoorkeuren';
      item.appendChild(link);legal.appendChild(item);
    }
    sync();
  }
  function trackStart(e) {
    var field=e.target;
    if(!field.matches('input:not([type="hidden"]),textarea,select')) return;
    var form=field.closest('form'), name=form&&forms[form.id];
    if(!allowed||!name||started[name])return;
    started[name]=true;emit('form_start',{form_name:name});
  }
  document.addEventListener('change',trackStart);
  document.addEventListener('input',trackStart);
  document.addEventListener('submit',function(e){
    var form=e.target, name=forms[form.id];
    if(!allowed||!name||!form.checkValidity())return;
    storageSet('ln_pending_'+name,String(Date.now()));
  },true);
  document.addEventListener('click',function(e){
    if(!allowed)return;
    var link=e.target.closest('a[href]');
    if(link){
      var href=link.getAttribute('href')||'', method='';
      if(/^tel:/i.test(href))method='phone';
      else if(/^mailto:/i.test(href))method='email';
      else if(/^https?:\/\/(wa\.me|api\.whatsapp\.com|web\.whatsapp\.com)(\/|$)/i.test(href))method='whatsapp';
      if(method){emit('contact_click',{contact_method:method});return;}
      try {
        var url=new URL(href,location.href);
        if(url.hostname===location.hostname && ['/pages/project-aanvragen','/pages/contact','/pages/kozijnconfigurator-demo-aanvragen'].indexOf(url.pathname)!==-1)emit('cta_click',{link_path:url.pathname});
        else if(['kozijnconfigurator.lninnovations.nl','isolatieconfigurator.lninnovations.nl','hekwerkconfigurator.lninnovations.nl'].indexOf(url.hostname)!==-1)emit('demo_open',{link_path:url.hostname});
        else if(url.hostname==='mijn.lninnovations.nl')emit('portal_open',{link_path:url.pathname});
      }catch(err){}
    }
    if(e.target.closest('[data-ln-next],[data-ln-previous]'))setTimeout(function(){
      var form=document.getElementById('LNProjectForm');if(!form)return;
      Array.from(form.querySelectorAll('[data-ln-form-step]')).forEach(function(step,index){
        var num=index+1;
        if(step.getClientRects().length && !stepsSeen[num]){stepsSeen[num]=true;emit('form_step',{form_name:'project',step_number:num});}
      });
    },0);
  });
  document.addEventListener('visitorConsentCollected',sync);
  function boot() {
    if(window.Shopify&&Shopify.customerPrivacy){consentUi();return;}
    if(window.Shopify&&Shopify.loadFeatures)Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(error){if(!error)consentUi();});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
